import type { QueryFunctionContext } from "@tanstack/query-core"
import type { AxiosResponse } from "axios"

import { axiosClient } from "$/http"

import { ECoachInfoQueryUrl, ECoachRatingQueryKey } from "@/3514/config"
import type { ICoachInfoDto } from "@/3514/types"
import { extractNumberFromQueryKeyPart } from "@/3514/utils"

async function coachInfoFetcher({
    queryKey
}: QueryFunctionContext<ReturnType<typeof ECoachRatingQueryKey>>): Promise<ICoachInfoDto> {
    const { data }: AxiosResponse<ICoachInfoDto> = await axiosClient.get(
        ECoachInfoQueryUrl({ participantId: extractNumberFromQueryKeyPart(queryKey[1]) })
    )

    return data
}

export { coachInfoFetcher }
